(ns dashboard.views.settings.shifts
  (:require
   [reagent.core :as reagent]
   [clojure.string :refer [split lower-case]]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen index-of vec-remove]]
   [dashboard.events.spaces :as space-events]
   [dashboard.components.drawer :refer [drawer]]
   [dashboard.components.button :refer [button]]
   [dashboard.components.select :refer
    [select space-select time-select multiselect]]
   [dashboard.components.inputs :refer [input textarea]]
   [dashboard.components.table :refer [table]]
   [dashboard.components.tag :refer [tag]]
   [dashboard.components.radiogroup :refer [color-circle color-group]]
   [dashboard.components.switch :refer [switch]]
   [dashboard.components.profile :refer [user-profile-img display-user-fullname]]
   [dashboard.components.command-palletes :refer [user-command-palletes]]
   ["@heroicons/react/solid" :refer [LocationMarkerIcon XIcon]]
   ["date-fns" :refer [formatISO formatDistance]]))

(defn- pattern-drawer-content [{:keys [state]}]
  [:div.relative.mt-6.flex-1.px-4.sm:px-6

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :shift-pattern/symbol)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "symbol"
       :name "symbol"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:pattern :symbol])
       :on-change #(swap! state assoc-in [:pattern :symbol] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :shift-pattern/startTime)]]
    [:div.sm:col-span-3.flex.space-x-2
     [time-select
      {:disabled? (= (:action @state) :view)
       :start-time "07:00"
       :end-time "20:00"
       :step-minutes 15
       :selected {:id (get-in @state [:pattern :startTime])
                  :name (get-in @state [:pattern :startTime])}
       :on-change #(swap! state assoc-in [:pattern :startTime] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :shift-pattern/endTime)]]
    [:div.sm:col-span-3.flex.space-x-2
     [time-select
      {:start-time "12:00"
       :end-time "23:00"
       :step-minutes 15
       :disabled? (= (:action @state) :view)
       :selected {:id (get-in @state [:pattern :endTime])
                  :name (get-in @state [:pattern :endTime])}
       :on-change #(swap! state assoc-in [:pattern :endTime] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :shift-pattern/hours)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "symbol"
       :name "symbol"
       :type "number"
       :step "any"
       :min "0"
       :max "24"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:pattern :hours])
       :on-change #(swap! state assoc-in [:pattern :hours] (js/parseFloat %))}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      "WIMS"]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "wims"
       :name "wims"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:pattern :wimsFormat])
       :on-change #(swap! state assoc-in [:pattern :wimsFormat] %)}]]]

   [:div.py-2.mt-3
    [textarea
     {:disabled (= (:action @state) :view)
      :label (tr :shift-pattern/description)
      :name "description"
      :id "description"
      :default-value (get-in @state [:pattern :description])
      :on-change #(swap! state assoc-in [:pattern :description] %)}]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-2
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :shift-pattern/isDayOff)]]
    [:div.sm:col-span-3
     [switch
      {:name "name"
       :checked? (get-in @state [:pattern :isDayOff])
       :on-change #(swap! state assoc-in [:pattern :isDayOff] (not (get-in @state [:pattern :isDayOff])))}]]]

   [:div.flex.flex-shrink-0.justify-end.py-4
    [button
     {:on-click
      (fn []
        (let [space (listen ::subs/selected-space)
              patterns (or (:shiftPatterns space) [])
              pattern (:pattern @state)
              idx (index-of (map :id patterns) (:id pattern))]
          (do
            (re-frame/dispatch
             (case (:action @state)
               :add [::space-events/update-space
                     {:space (assoc space :shiftPatterns (conj patterns pattern))}]
               :delete [::space-events/update-space
                        {:space (assoc space :shiftPatterns
                                       (into [] (filter #(not= (:id pattern) (:id %)) patterns)))}]
               :edit [::space-events/update-space
                      {:space (assoc-in space [:shiftPatterns idx] pattern)}]
               ""))
            (reset! state {:is-open? false
                           :action nil
                           :pattern nil
                           :tag nil}))))}
     (case (:action @state)
       :add (tr :action/create)
       :delete (tr :action/delete)
       :edit (tr :action/save)
       "")]]])

(defn- tag-drawer-content [{:keys [state]}]
  [:div.relative.mt-6.flex-1.px-4.sm:px-6

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :shfit-tag/symbol)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "symbol"
       :name "symbol"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:tag :symbol])
       :on-change #(swap! state assoc-in [:tag :symbol] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :shfit-tag/color)]]
    [:div.sm:col-span-3.w-full.flex
     [color-group
      {:class "flex"
       :selected (get-in @state [:tag :color])
       :on-change #(swap! state assoc-in [:tag :color] %)
       :size 4
       :colors (listen ::subs/colors)}]]]

   [:div.py-2.mt-3
    [textarea
     {:disabled (= (:action @state) :view)
      :label (tr :shift-tag/description)
      :name "description"
      :id "description"
      :default-value (get-in @state [:tag :description])
      :on-change #(swap! state assoc-in [:tag :description] %)}]]

   [:div.flex.flex-shrink-0.justify-end.py-4
    [button
     {:on-click
      (fn []
        (let [space (listen ::subs/selected-space)
              tags (or (:shiftTags space) [])
              tag (:tag @state)
              idx (index-of (map :id tags) (:id tag))]
          (do
            (re-frame/dispatch
             (case (:action @state)
               :add [::space-events/update-space
                     {:space (assoc space :shiftTags (conj tags tag))}]
               :delete [::space-events/update-space
                        {:space (assoc space :shiftTags
                                       (into [] (filter #(not= (:id tag) (:id %)) tags)))}]
               :edit [::space-events/update-space
                      {:space (assoc-in space [:shiftTags idx] tag)}]
               ""))
            (reset! state {:is-open? false
                           :action nil
                           :pattern nil
                           :tag nil}))))}
     (case (:action @state)
       :add (tr :action/create)
       :delete (tr :action/delete)
       :edit (tr :action/save)
       "")]]])

(defn- formula-drawer-content [{:keys [state command-state]}]
  (let [formula (:formula @state)
        shift-pattern-ids (into #{} (:patternIds formula))
        shift-patterns (->> (:patternIds formula)
                            (map #(get (listen ::subs/shift-patterns-by-id) %)))
        team-ids (into #{} (:teamIds formula))
        teams (->> (:teamIds formula)
                   (map #(get (listen ::subs/teams-by-id) %)))
        user-ids (into #{} (:userIds formula))
        users (->> (:userIds formula)
                   (map #(get (listen ::subs/staffs-by-id) %)))]
    [:div.relative.mt-6.flex-1.px-4.sm:px-6

     [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
      [:div
       [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
        (tr :shift.formula/symbol)]]
      [:div.sm:col-span-3
       [input
        {:auto-complete "symbol"
         :name "symbol"
         :type "text"
         :disabled? (= (:action @state) :view)
         :default-value (get-in @state [:formula :symbol])
         :on-change #(swap! state assoc-in [:formula :symbol] %)}]]]

     [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
      [:div
       [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
        (tr :shift.formula/color)]]
      [:div.sm:col-span-3.w-full.flex
       [color-group
        {:class "flex"
         :selected (get-in @state [:formula :color])
         :on-change #(swap! state assoc-in [:formula :color] %)
         :size 4
         :colors (listen ::subs/colors)}]]]

     [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
      [:div
       [:label.block.text-xs.font-medium.text-gray-900.sm:mt-px.sm:pt-2
        (tr :shift.formula/patterns)]]
      [:div.sm:col-span-3.flex.space-x-2
       [multiselect
        {:class "w-full"
         :selected shift-patterns
         :items-list (listen ::subs/shift-patterns)
         :id-key :id
         :name-key :symbol
         :on-change #(swap! state assoc-in [:formula :patternIds]
                            (if (some? (shift-pattern-ids %))
                              (into [] (disj shift-pattern-ids %))
                              (into [] (conj shift-pattern-ids %))))}]]]

     [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
      [:div
       [:label.block.text-xs.font-medium.text-gray-900.sm:mt-px.sm:pt-2
        (tr :shift.formula/teams)]]
      [:div.sm:col-span-3.flex.space-x-2
       [multiselect
        {:class "w-full"
         :selected teams
         :items-list (listen ::subs/teams)
         :id-key :id
         :name-key :name
         :on-change #(swap! state assoc-in [:formula :teamIds]
                            (if (some? (team-ids %))
                              (into [] (disj team-ids %))
                              (into [] (conj team-ids %))))}]]]

     [:div.py-2.mt-3
      [:div.flex.justify-between.items-center
       [:label.block.text-sm.font-medium.text-gray-700
        (tr :shift.formula/users)
        (when (not (empty? users))
          [:span.ml-1
           (str "(" (count users) ")")])]
       [button
        {:disabled? (= (:action @state) :view)
         :small? true
         :on-click #(reset! command-state {:is-open? true})}
        (tr :action/add)]]

      [:div.-mx-4.mt-2.flex.flex-col.sm:-mx-6.md:mx-0.mb-4
       [:table.divide-y.divide-gray-300
        [:thead
         [:tr
          [:th.pl-4.pr-3.text-left.text-sm.font-semibold.text-gray-900.sm:pl-6.md:pl-0
           {:class "py-2.5"
            :scope "col"}
           (tr :user)]
          [:th.pr-3.text-right.text-sm.font-semibold.text-gray-900
           {:class "py-2.5"
            :scope "col"}
           [:span.sr-only (tr :action/edit)]]]]
        [:tbody
         (if (not (empty? users))
           (doall
            (for [[idx user-id] (->> user-ids
                                     (map-indexed vector))
                  :let [user (get (listen ::subs/staffs-by-id) (str user-id))]]
              ^{:key user-id}
              [:tr
               [:td.py-1.px-2.font-semibold.text-sm.flex.items-center
                (display-user-fullname user)]
               [:td.whitespace-nowrap.py-1.pl-2.text-right.text-sm.font-medium.pr-3
                [:a.text-primary-600.hover:text-primary-900
                 {:type "button"
                  :on-click #(swap! state assoc-in [:formula :userIds]
                                    (vec-remove (into [] (get-in @state [:formula :userIds])) idx))}
                 [:> XIcon
                  {:class "h-4 w-4"
                   :aria-hidden true}]]]]))
           [:tr.divide-x
            [:td.py-1.px-2.text-sm.flex.items-center
             {:scope "row"
              :colSpan 3}
             (tr :non-ideal/no-entries-to-show)]])]
        [:tfoot
         [:tr]]]]]

     [:div.flex.flex-shrink-0.justify-end.py-4
      [button
       {:on-click
        (fn []
          (let [space (listen ::subs/selected-space)
                formulas (or (:shiftFormulas space) [])
                formula (:formula @state)
                idx (index-of (map :id formulas) (:id formula))]
            (do
              (re-frame/dispatch
               (case (:action @state)
                 :add [::space-events/update-space
                       {:space (assoc space :shiftFormulas (conj formulas formula))}]
                 :delete [::space-events/update-space
                          {:space (assoc space :shiftFormulas
                                         (into [] (filter #(not= (:id formula) (:id %)) formulas)))}]
                 :edit [::space-events/update-space
                        {:space (assoc-in space [:shiftFormulas idx] formula)}]
                 ""))
              (reset! state {:is-open? false
                             :action nil
                             :pattern nil
                             :tag nil
                             :formula nil}))))}
       (case (:action @state)
         :add (tr :action/create)
         :delete (tr :action/delete)
         :edit (tr :action/save)
         "")]]]))

(defn content []
  (let [!drawer-state (reagent/atom {:pattern nil
                                     :tag nil
                                     :is-open? false
                                     :action nil})
        !command-state (reagent/atom {:is-open? false})]
    (fn []
      (let [default-shift-pattern {:id (str (random-uuid))
                                   :symbol ""
                                   :description ""
                                   :startTime "09:00"
                                   :endTime "20:00"
                                   :wimsFormat ""
                                   :isDayOff false
                                   :hours 7.5}
            default-shift-tag {:id (str (random-uuid))
                               :symbol ""
                               :description ""
                               :color "red"}
            default-shift-formula {:id (str (random-uuid))
                                   :symbol ""
                                   :color "red"
                                   :patternIds []
                                   :userIds []
                                   :teamIds []}]
        [:div.divide-y.divide-gray-200
         [drawer
          {:state !drawer-state
           ;; TODO: Refactor this in something more concise
           :title (cond
                    (and (= (:action @!drawer-state) :add)
                         (some? (:pattern @!drawer-state)))
                    (tr :action/add-fn (tr :shift/pattern))

                    (and (= (:action @!drawer-state) :delete)
                         (some? (:pattern @!drawer-state)))
                    (tr :action/delete-fn (tr :shift/pattern))

                    (and (= (:action @!drawer-state) :edit)
                         (some? (:pattern @!drawer-state)))
                    (tr :action/edit-fn (tr :shift/pattern))

                    (and (= (:action @!drawer-state) :add)
                         (some? (:tag @!drawer-state)))
                    (tr :action/edit-fn (tr :shift/tag))

                    (and (= (:action @!drawer-state) :delete)
                         (some? (:tag @!drawer-state)))
                    (tr :action/delete-fn (tr :shift/tag))

                    (and (= (:action @!drawer-state) :edit)
                         (some? (:tag @!drawer-state)))
                    (tr :action/edit-fn (tr :shift/tag))

                    (and (= (:action @!drawer-state) :add)
                         (some? (:formula @!drawer-state)))
                    (tr :action/edit-fn (tr :shift/formula))

                    (and (= (:action @!drawer-state) :delete)
                         (some? (:formula @!drawer-state)))
                    (tr :action/delete-fn (tr :shift/formula))

                    (and (= (:action @!drawer-state) :edit)
                         (some? (:formula @!drawer-state)))
                    (tr :action/edit-fn (tr :shift/formula))

                    :else "")
           :content (cond
                      (some? (:pattern @!drawer-state))
                      [pattern-drawer-content
                       {:state !drawer-state}]

                      (some? (:tag @!drawer-state))
                      [tag-drawer-content
                       {:state !drawer-state}]

                      (some? (:formula @!drawer-state))
                      [formula-drawer-content
                       {:state !drawer-state
                        :command-state !command-state}]

                      :else [:div])}]
         [user-command-palletes
          {:state !command-state
           :on-click #(swap! !drawer-state assoc-in [:formula :userIds]
                             (conj (get-in !drawer-state [:formula :userIds] []) %))
           :default-filters {:space (listen ::subs/selected-space-id)}}]

         [:div.px-4.pt-6.pb-2
          [:div.sm:flex.sm:items-center
           [:div.sm:flex-auto
            [space-select
             {:class "w-64"
              :selected (listen ::subs/selected-space)
              :on-change #(do
                            (re-frame/dispatch [::space-events/select-space {:id %}])
                            (re-frame/dispatch [:navigate :route.settings/shifts
                                                {:space-id (str %)}]))}]]]]

         ;; Shift Pattern
         [:div.my-4
          [:div.pt-6.px-4.sm:px-6
           [:div
            [:h2.text-lg.leading-6.font-medium.text-gray-900
             (tr :shift/patterns)]
            #_[:p.mt-1.text-sm.text-gray-500
               "Store shift patterns settings configuration."]]]]

         [:div
          [:div.px-4.pt-6
           [:div.sm:flex.sm:items-center
            [:div.sm:flex-auto]
            [:div.mt-4.sm:mt-0.sm:ml-16.sm:flex-none
             [button
              {:on-click #(reset! !drawer-state {:is-open? true
                                                 :action :add
                                                 :pattern default-shift-pattern})}
              (tr :action/add-fn (tr :shift/pattern))]]]]
          [:div.py-6.px-4
           [table
            {:headers [{:title (tr :shift-pattern/symbol)
                        :key :symbol
                        :class "w-24 text-center"
                        :render-cell (fn [symbol]
                                       [:span.flex.items-center.font-semibold.justify-center
                                        symbol])}
                       {:title (tr :shift-pattern/startTime)
                        :key :startTime
                        :class "w-24"
                        :render-cell (fn [start]
                                       [:span
                                        start])}
                       {:title (tr :shift-pattern/endTime)
                        :key :endTime
                        :class "w-24"
                        :render-cell (fn [end]
                                       [:span
                                        end])}
                       {:title (tr :shift-pattern/hours)
                        :key :hours
                        :class "w-16"
                        :render-cell (fn [hours]
                                       [:span.flex.justify-center
                                        hours])}
                       {:title "WIMS"
                        :key :wimsFormat
                        :class "w-12"
                        :render-cell (fn [symbol]
                                       [:code.flex.items-center.justify-center.text-primary.text-xs
                                        symbol])}
                       {:title (tr :shift-pattern/description)
                        :key :description
                        :render-cell (fn [description]
                                       [:div.text-gray-700
                                        description])}]
             :rows (listen ::subs/shift-patterns)
             :actions [{:name :edit
                        :text (tr :action/edit)
                        :on-click #(reset! !drawer-state {:is-open? true
                                                          :action :edit
                                                          :pattern %})}
                       {:name :delete
                        :text (tr :action/delete)
                        :on-click #(reset! !drawer-state {:is-open? true
                                                          :action :delete
                                                          :pattern %})}]}]]]


         ;; Shift Tags
         [:div.my-4
          [:div.pt-6.px-4.sm:px-6
           [:div
            [:h2.text-lg.leading-6.font-medium.text-gray-900
             (tr :shift/tags)]
            #_[:p.mt-1.text-sm.text-gray-500
               "Store Shifts tags settings configuration"]]]]

         [:div
          [:div.px-4.pt-6
           [:div.sm:flex.sm:items-center
            [:div.sm:flex-auto]
            [:div.mt-4.sm:mt-0.sm:ml-16.sm:flex-none
             [button
              {:on-click #(reset! !drawer-state {:is-open? true
                                                 :action :add
                                                 :tag default-shift-tag})}
              (tr :action/add-fn (tr :shift/tag))]]]]
          [:div.py-6.px-4
           [table
            {:headers [{:title (tr :shift-tag/color)
                        :key :color
                        :class "w-10"
                        :render-cell (fn [color]
                                       [:div.flex.justify-center
                                        [color-circle
                                         {:color color
                                          :size 6}]])}
                       {:title (tr :shift-tag/symbol)
                        :key :symbol
                        :class "w-24"
                        :render-cell (fn [symbol]
                                       [:span.flex.items-center.font-semibold.justify-center
                                        symbol])}
                       {:title (tr :shift-tag/description)
                        :key :description
                        :render-cell (fn [description]
                                       [:div.text-gray-700
                                        description])}]
             :rows (listen ::subs/shift-tags)
             :actions [{:name :edit
                        :text (tr :action/edit)
                        :on-click #(reset! !drawer-state {:is-open? true
                                                          :action :edit
                                                          :tag %})}
                       {:name :delete
                        :text (tr :action/delete)
                        :on-click #(reset! !drawer-state {:is-open? true
                                                          :action :delete
                                                          :tag %})}]}]]]

         ;; Shift Formula
         [:div.my-4
          [:div.pt-6.px-4.sm:px-6
           [:div
            [:h2.text-lg.leading-6.font-medium.text-gray-900
             (tr :shift/formula)]
            #_[:p.mt-1.text-sm.text-gray-500
               "A combination for patterns and filters"]]]]

         [:div
          [:div.px-4.pt-6
           [:div.sm:flex.sm:items-center
            [:div.sm:flex-auto]
            [:div.mt-4.sm:mt-0.sm:ml-16.sm:flex-none
             [button
              {:on-click #(reset! !drawer-state {:is-open? true
                                                 :action :add
                                                 :formula default-shift-formula})}
              (tr :action/add-fn (tr :shift/formula))]]]]
          [:div.py-6.px-4
           [table
            {:headers [{:title (tr :shift.formula/color)
                        :key :color
                        :class "w-10"
                        :render-cell (fn [color]
                                       [:div.flex.justify-center
                                        [color-circle
                                         {:color color
                                          :size 6}]])}
                       {:title (tr :shift.formula/symbol)
                        :key :symbol
                        :class "w-24 text-center"
                        :render-cell (fn [symbol]
                                       [:span.flex.items-center.font-semibold.justify-center
                                        symbol])}
                       {:title (tr :shift.formula/patterns)
                        :key :patternIds
                        :render-cell (fn [pattern-ids formula]
                                       [:div.text-gray-700.space-x-2
                                        (doall
                                         (for [pattern-id pattern-ids
                                               :let [pattern (get (listen ::subs/shift-patterns-by-id) pattern-id)]]
                                           ^{:key (str (:id formula) "-" (:id pattern))}
                                           [:span (:symbol pattern)]))])}
                       {:title (tr :shift.formula/teams)
                        :key :teamIds
                        :render-cell (fn [team-ids formula]
                                       [:div.text-gray-700.space-x-2
                                        (doall
                                         (for [team-id team-ids
                                               :let [team (get (listen ::subs/teams-by-id) team-id)]]
                                           ^{:key (str (:id formula) "-" (:id team))}
                                           [tag
                                            {:color (:color team)}
                                            (:name team)]))])}
                       {:title (tr :shift.formula/users)
                        :key :userIds
                        :render-cell (fn [user-ids formula]
                                       [:div.text-gray-700.space-x-2
                                        (doall
                                         (for [user-id user-ids
                                               :let [user (get (listen ::subs/staffs-by-id) user-id)]]
                                           ^{:key (str (:id formula) "-" (:id user))}
                                           [user-profile-img
                                            {:user user}]))])}]
             :rows (listen ::subs/shift-formulas)
             :actions [{:name :edit
                        :text (tr :action/edit)
                        :on-click #(reset! !drawer-state {:is-open? true
                                                          :action :edit
                                                          :formula %})}
                       {:name :delete
                        :text (tr :action/delete)
                        :on-click #(reset! !drawer-state {:is-open? true
                                                          :action :delete
                                                          :formula %})}]}]]]

         [:div.divide-y.divide-gray-200
          [:div
           [:div.py-4.px-4.flex.justify-end.sm:px-6
            [button
             {:type "submit"}
             (tr :action/save)]]]]]))))
